module.exports = __webpack_public_path__ + "static/media/Srilakshmi R.a43dd08b.jpg";